<template>
  <b-container>
<h1>Registration</h1>
<b-table :items="courses"></b-table>
  </b-container>
</template>
<script>
import { mixins } from "../mixins";

export default {
  name: "registration",
  mixins: [mixins],
  data() {
    return {
      courses: []
    }
  },
  created() {
    this.pullCourses();
  },
  methods: {
    pullCourses() {
      this.api("/secure/register")
        .then(response => {
          this.courses = response.data;
        })
        .catch(error => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    }
  }
};
</script>
